import {Logger} from "./Logger";

const timer = (category: string, label: string) => {
  // tslint:disable-next-line:ban-types
  return (_target: Object, key: string, descriptor: TypedPropertyDescriptor<(...args: any[]) => Promise<any>>) => {
    const originalMethod = descriptor.value;

    if (!originalMethod) {
      return descriptor;
    }

    descriptor.value = function (...args: any[]) {
      const time = performance.now();
      const result = originalMethod.apply(this, args);

      result
        .then(() => {
          Logger.logCustomTiming({category, key, label, time: Math.round(performance.now() - time)});
        })
        .catch((e: Error) => {
          // Maybe this is too much, but we'll see
          Logger.logCustomTiming({
            category,
            key: `${key} - Exception: ${e.message}`,
            label,
            time: Math.round(performance.now() - time),
          });
        });

      return result;
    };

    return descriptor;
  };
};

export default timer;
